import React from 'react'
import { CustomInput } from '../customInput/CustomInput'

export const CustomFormFloating = ({
    status,
    name,
    label,
    labelClassName,
    type,
    className,
    children,
    hrtag,
    value,
    readOnly,
    formClass = '' }) => {
    return (
        <div className={`form-floating ${formClass}`}>


            {status ?

                <>{children}</>
                :
                <CustomInput
                    hrtag={hrtag}
                    type={type}
                    className={className}
                    name={name}
                    label={label}
                    value={value}
                    labelClassName={labelClassName}
                    readOnly={readOnly}

                />

            }
        </div>
    )
}
